import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

import { useTranslation } from '@common/hooks/translation';
import { swarmList, useSwarm } from '@lbs/swarm-client';
import DatePicker from '@common/components/datePicker';
import Dropdown from '@common/components/dropdown';
import { getTodayDateRange } from '@common/helpers/getTodayDateRange';
import { getVirtualSportWithGameCount } from '@common/helpers/requests/virtualSports';
import Config from '@app/dev/config/main';

const query = getVirtualSportWithGameCount([1]);

const Filters = ({
  dateFilter,
  setDateFilter,
  selectedSport,
  setSelectedSport,
}) => {
  const t = useTranslation();
  const { sport = {} } = useSwarm(query, false);
  const virtualSportList = swarmList(sport);

  const [startDate, endDate] = dateFilter;

  useEffect(() => {
    if (!selectedSport) {
      setSelectedSport({
        value: virtualSportList[0].name,
        ..._.pick(virtualSportList[0], ['name', 'id', 'alias']),
      });
    }
  }, [selectedSport, setSelectedSport, virtualSportList]);

  const changeDate = ([newStart, newEnd]) => {
    setDateFilter([
      newStart && moment(newStart).startOf('D').toDate(),
      newEnd && moment(newEnd).endOf('D').toDate(),
    ]);
  };

  const options = useMemo(
    () => virtualSportList.map((item) => ({
      value: item.name,
      ..._.pick(item, ['name', 'id', 'alias']),
    })).filter(item => !Config.main.sportsIdsBlackList.includes(item.id)),
    [virtualSportList],
  );

  const onReset = () => {
    setDateFilter(getTodayDateRange());
  };

  if (!selectedSport) return null;

  const today = new Date();
  const maxRange = new Date(startDate).setDate(startDate.getDate() + 5);

  return (
    <div className="virtuals-filters">
      <div>
        <DatePicker
          startDate={startDate}
          endDate={endDate}
          onChange={changeDate}
          selectsRange
          maxDate={maxRange > today ? today : maxRange}
        />
      </div>

      <Dropdown
        value={selectedSport.value}
        options={options}
        placeholder={t('Sport')}
        onChange={setSelectedSport}
      />
      <button type="button" className="r-p-btn-reset" onClick={onReset}>
        {t('Reset')}
      </button>
    </div>
  );
};

Filters.propTypes = {
  dateFilter: PropTypes.object.isRequired,
  setDateFilter: PropTypes.func.isRequired,
  selectedSport: PropTypes.object,
  setSelectedSport: PropTypes.func.isRequired,
};

export default Filters;
